import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PermissionRuntimeConfig {
  enablePermissionChecks: boolean;
  bypassAllPermissions: boolean;
}

@Injectable({ providedIn: 'root' })
export class PermissionConfigService {
  private readonly subject = new BehaviorSubject<PermissionRuntimeConfig>({
    enablePermissionChecks: environment.enablePermissionChecks ?? true,
    bypassAllPermissions: environment.bypassAllPermissions ?? false,
  });

  readonly config$ = this.subject.asObservable();

  getConfig(): PermissionRuntimeConfig {
    return this.subject.value;
  }

  getConfig$(): Observable<PermissionRuntimeConfig> {
    return this.config$;
  }

  updateConfig(partial: Partial<PermissionRuntimeConfig>): void {
    this.subject.next({ ...this.subject.value, ...partial });
  }
}
